"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
function isNumber(number) {
    return typeof number === 'number' && !isNaN(number);
}
const parseDateTime = (dateTime) => {
    if (isNumber(dateTime) && dateTime < 10e9) {
        return date_fns_1.parse(dateTime * 1000);
    }
    return date_fns_1.parse(dateTime);
};
exports.default = parseDateTime;
